import { WORLD_CUP_WELCOME } from '../../../src/worldcup/worldcup.constants';

/**
 * Visual layout for the points tutorial timeline (alternating cards).
 * Icons follow tournament flow: flag = early rounds (group + R32), swords = knockout bracket (R16/QF), trophy → medal for the closing rounds.
 * Must stay aligned with `WORLD_CUP_WELCOME.POINTS_TABLE.ROWS` length and order.
 */
export const WELCOME_POINTS_TIMELINE_LAYOUT = [
  { align: 'left' as const,  compact: false, icon: 'flag' as const },
  { align: 'right' as const, compact: false, icon: 'flag' as const },
  { align: 'left' as const,  compact: false, icon: 'swords' as const },
  { align: 'right' as const, compact: false, icon: 'swords' as const },
  { align: 'left' as const,  compact: true,  icon: 'trophy' as const },
  { align: 'right' as const, compact: true,  icon: 'medal' as const },
  { align: 'left' as const,  compact: true,  icon: 'trophy' as const },
] as const;

export type WelcomePointsTimelineIconId =
  (typeof WELCOME_POINTS_TIMELINE_LAYOUT)[number]['icon'];

const ROWS = WORLD_CUP_WELCOME.POINTS_TABLE.ROWS;

if (ROWS.length !== WELCOME_POINTS_TIMELINE_LAYOUT.length) {
  throw new Error(
    'WelcomePointsPhase: timeline layout count must match POINTS_TABLE.ROWS',
  );
}

export type WelcomePointsTimelineStage = (typeof ROWS)[number] &
  (typeof WELCOME_POINTS_TIMELINE_LAYOUT)[number] & {
    id: string;
  };

export const WELCOME_POINTS_TIMELINE_STAGES: readonly WelcomePointsTimelineStage[] =
  ROWS.map((row, index) => ({
    ...row,
    ...WELCOME_POINTS_TIMELINE_LAYOUT[index],
    id: row.stage,
  }));
